import type {
  Employee,
  KnowledgeSearchResult,
  NewsPost,
  TeamWithCounts,
  WorkstreamBasic,
} from 'client';

import type {Meeting} from './useMeetings';

/** Anything the search box lists or shows in its pane. */
export type SearchRow =
  | {kind: 'person'; id: string; person: Employee}
  | {kind: 'team'; id: string; team: TeamWithCounts}
  | {kind: 'workstream'; id: string; workstream: WorkstreamBasic}
  | {kind: 'news'; id: string; post: NewsPost}
  /** A knowledge article or home link. */
  | {kind: 'knowledge'; id: string; result: KnowledgeSearchResult}
  | {kind: 'meeting'; id: string; meeting: Meeting}
  /** The typed query, asked as is. */
  | {kind: 'ask'; id: string; question: string}
  /** A suggested question in the empty box. */
  | {kind: 'askSuggestion'; id: string; question: string};

/**
 * Company questions Ask answers well from the knowledge base, two shown per
 * open (their i18n keys; the text is what gets asked). Nothing that needs
 * data Ask can't see (a PTO balance, your pay).
 */
export const COMPANY_ASKS = [
  'search_box_company_ask_zoom',
  'search_box_company_ask_monitor',
  'search_box_company_ask_401k',
  'search_box_company_ask_virtual_first',
  'search_box_company_ask_laptop',
  'search_box_company_ask_benefits',
];
